var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-icon-button.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-icon.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import "@adornis/popover/x-tooltip.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
var XIconButton = class extends ChemistryLitElement {
  render() {
    return xComponents(html`
      <x-flex
        horizontal
        crossaxis-center
        space="xxs"
        ${css({
      padding: this.spacing.xs,
      background: this.backgroundColor ?? "#bbbbb4",
      color: this.color ?? "#333",
      borderRadius: "5px",
      cursor: "pointer"
    })}
      >
        <x-icon> ${this.icon} </x-icon>
        ${this.text ? html` <x-text> ${this.text} </x-text> ` : nothing}
        <slot></slot>
      </x-flex>
    `);
  }
};
__decorateClass([
  property({ attribute: "text" })
], XIconButton.prototype, "text", 2);
__decorateClass([
  property({ attribute: "icon" })
], XIconButton.prototype, "icon", 2);
__decorateClass([
  property({ attribute: "background" })
], XIconButton.prototype, "backgroundColor", 2);
__decorateClass([
  property({ attribute: "color" })
], XIconButton.prototype, "color", 2);
XIconButton = __decorateClass([
  customElement("x-icon-button")
], XIconButton);
export {
  XIconButton
};
